import './FloatingButton.dark.less';
import './FloatingButton.desktop.less';
import './FloatingButton.less';
import clsx from 'clsx';
import React, { MouseEventHandler, useEffect, useState } from 'react';
import PencilCrossedIcon from '../../icons/svg/pencil-crossed-icon-sv.svg';
import PencilIcon from '../../icons/svg/pencil-rubber-icon-sv.svg';
import { motion } from 'framer-motion';
import i18n from '../../common/i18n';

export interface FloatingButtonProps {
    label?: string;
    onClick: MouseEventHandler;
    disabled?: boolean;
    isChat?: boolean;
    dataAtid?: string;
}

export default function FloatingButton({ label, onClick, disabled, isChat, dataAtid }: FloatingButtonProps) {
    const [animDelay, setAnimDelay] = useState(3);

    useEffect(() => {
        const interval = setInterval(() => {
            setAnimDelay(0);
        }, 3000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    const transitionSetup = {
        ease: 'easeInOut',
        delay: animDelay
    };

    const nestedVariants = {
        hovering: { transition: transitionSetup, width: 'auto' },
        resting: { transition: transitionSetup, width: 0 }
    };

    return (
        <motion.button
            initial="hovering"
            animate="resting"
            whileHover="hovering"
            className={clsx('nui-button floating-button on-load-animation', { 'floating-button-disabled': disabled })}
            type="button"
            onClick={disabled ? null : onClick}
            data-atid={dataAtid}
        >
            <motion.div className="floating-button-content" variants={nestedVariants}>
                <span className="floating-button-label">{label}</span>
                <div className="floating-button-vertical-line mx-20" />
            </motion.div>
            {isChat ? (
                <div className="chat-floating-button">{i18n('chat.title')}</div>
            ) : disabled ? (
                <PencilCrossedIcon width="26px" height="26px" />
            ) : (
                <PencilIcon width="26px" height="26px" />
            )}
        </motion.button>
    );
}
